import { createUseStyles } from 'react-jss';
import { theme } from '../theme';

const PREFIX = 'Avatar';
export const useStyles = createUseStyles(
  {
    avatar: {
      width: 32,
      height: 32,
      fontSize: 12,
      fontFamily: theme.sfPro,
      fontWeight: 600,
      borderRadius: 16,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    big: {
      margin: 0,
      width: 152,
      height: 152,
      fontSize: 50,
    },
    style1: {
      background: '#30A1E5',
      color: '#FFFFFF',
    },
    style2: {
      background: '#EF6195',
      color: '#FFFFFF',
    },
    style3: {
      background: '#30A1E5',
      color: '#FFFFFF',
    },
    style4: {
      background: '#EF6195',
      color: '#FFFFFF',
    },
  },
  { name: PREFIX },
);
